import React from 'react'


export default function InfoItem({ icon: Icon, label, children, full }) {
    return (
      <div className={`info-item ${full ? "w-100" : ""}`}>
        <Icon size={16} />
        <div id={label}>
          <label htmlFor={label}>{label}</label>
          <div id={`${label}-value`}>{children}</div>
        </div>
      </div>
    );
  }